export const DESKTOP_NAV_HEIGHT = 87;

export default { DESKTOP_NAV_HEIGHT };
